
import { Component, Prop, Vue } from "vue-property-decorator";
import { systemSrv } from "./../../services/system";

@Component
export default class Header extends Vue {
  backupQr
  qrcode = {
    data:"",
    url:""
  }
  qrCodeUrl = this.$store.getters.config.memberAPIUrl+"qr/standard";
  
  created() {
    //this.loadQr()
  }

  hideQr(){
    this.qrcode['data'] = ""
  }
  async loadQr(){
    if(this.backupQr){
      this.qrcode['data'] = this.backupQr
      return
    }
    this.qrcode['data'] = await systemSrv.loadQRCode('standard');
    this.backupQr = this.qrcode['data']
  }
}
